var _circle, _circle2, _circle3, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 45,
    cy: 45,
    r: 45,
    fill: "#02C697"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 44.9999,
    cy: 44.9998,
    r: 36.8182,
    fill: "#02C697"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.6,
    cx: 44.9996,
    cy: 44.9996,
    r: 28.6364,
    fill: "#02C697"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.1412 37.8592C55.9223 38.6403 55.9223 39.9066 55.1412 40.6877L43.1412 52.6876C42.3602 53.4687 41.0938 53.4687 40.3128 52.6876L34.8582 47.2331C34.0772 46.4521 34.0772 45.1857 34.8582 44.4047C35.6393 43.6236 36.9056 43.6236 37.6867 44.4047L41.727 48.445L52.3128 37.8592C53.0938 37.0782 54.3602 37.0782 55.1412 37.8592Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/Success.d59d04dbb116bdfe324d9bb016a86ec3.svg";
export { ForwardRef as ReactComponent };